import { defineComponent as _defineComponent } from 'vue'
import { userService } from "@/services/internal-api/auth.service";
import store from "@/state/store";
import { computed } from "vue";
import cache from "@/services/cache/cache.service";


export default /*#__PURE__*/_defineComponent({
  __name: 'team-impersonation-modal',
  setup(__props) {

const name = computed(() => {
  return (
    store.getters["auth/authFirstName"] +
    " " +
    store.getters["auth/authLastName"]
  );
});

const email = computed(() => {
  return store.getters["auth/authEmail"];
});

const teamOwner = computed(() => {
  return store.getters["auth/authTeamOwner"]?.user;
});

async function revertToTeamOwner() {
  await store.dispatch("auth/swapTeamOwnerToActive");
  userService.confirmLogin(
    {
      data: {
        user: store.getters["auth/authUser"],
        token: store.getters["auth/authToken"],
      },
    },
    "team_owner_impersonation"
  );

  cache.clear("content");
}

return { __sfc: true,name, email, teamOwner, revertToTeamOwner }
}

})